import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import studygameActions from '../store/actions/studygameActions'
import { Emoji } from '../components/ReactionIcons'
import Button from '../components/Button'
import ReorderWord from '../components/minigames/ReorderWord'
import ReorderTitle from '../components/minigames/ReorderTitle'
import GuessImage from '../components/minigames/GuessImage'
import GuessTitle from '../components/minigames/GuessTitle'
import GuessWord from '../components/minigames/GuessWord'
import AnimationLayout from '../components/AnimationLayout'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import PuzzleMinigame from '../components/minigames/PuzzleNews'
import MatildeBalloon from '../components/MatildeBalloon'

function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
}

/* const ptSources = [
    ["Expresso", "expresso.pt"],
    ["Público", "publico.pt"],
    ["Observador", "observador.pt"],
    ["Sapo", "sapo.pt"]
]

const enSources = [
    ["Time", "time.com"],
    ["The Washington Post", "washingtonpost.com"],
    ["CNN", "cnn.com"],
    ["BBC", "bbc.co.uk"],
    ["Independent", "independent.co.uk"],
] */

const themes = [
    ["Saúde", "health"],
    ["Tecnologia", "technology"],
    ["Desporto", "sports"],
    ["Entretenimento", "entertainment"],
    ["Ciência", "science"],
]

const StudyGame = () => {

    const initState = {
        step: 0,
        language: null,
        category: []
    }

    const [state, setState] = useState(initState)

    const handleChange = (event) => {
        const { name, value } = event.target

        if (name === 'category') {
            console.log(state.category.find(item => item === value) ? true : false)
            if (state.category.find(item => item === value) ? true : false) {
                const filter = state.category.filter((item, index, arr) => item !== value)
                setState({ ...state, category: [...filter] })
            } else {
                setState({ ...state, category: [...state.category, value] })
            }
        } else {
            setState({ ...state, [name]: value })
        }
    }

    const handleForward = () => {
        setState({ ...state, step: state.step += 1 })
    }

    const handleBack = () => {
        setState({ ...state, step: state.step - 1, })
    }

    const steps = [
        { title: 'Escolher idioma' },
        { title: 'Escolher temas' },
    ]

    const getStepContent = (step, languageItem) => {
        switch (step) {
            case 0:
                return (
                    <div>
                        <p className='pb-3'>Escolha o idioma das notícias do jogo</p>
                        <label className='flex items-center mb-2'>
                            <input type="radio" name="language" value="pt" onClick={handleChange} />
                            <span className='pl-2'>Português</span>
                        </label>

                        <label className='flex items-center'>
                            <input type="radio" name="language" value="en" onClick={handleChange} />
                            <span className='pl-2'>Inglês</span>
                        </label>
                        <div className='py-3'>
                            <Button className='mr-2 mb-2' disabled={!state.language ? true : false} onClick={handleForward}>Próximo</Button>
                        </div>
                    </div>
                )
            case 1:

                return (
                    <div>
                        <p className='pb-3'>Escolha pelo menos <b>3 temas</b> para as notícias</p>

                        {themes.map((item, index) => (
                            <label key={index} className='flex items-center mb-2'>
                                <input type="checkbox" name="category" value={item[1]} onClick={handleChange} />
                                <span className='pl-2'>{item[0]}</span>
                            </label>
                        ))}


                        <div className='py-4 py-4 mb-2 flex flex-wrap items-center'>
                            <Button onClick={handleBack} className='mr-2'>Voltar</Button>
                            <Button
                                className='mr-2'
                                disabled={state.category.length < 3 ? true : false}
                                onClick={() => {
                                    dispatch(studygameActions.startStudyGame(languageItem, state.category))
                                }}
                            >
                                Começar
                            </Button>
                        </div>
                    </div>
                )
            default:
                return 'Unknown step';
        }
    }

    const dispatch = useDispatch()
    const { step, language } = state
    const studyGameState = useSelector(state => state.studyGame)
    const { isGameOn, didGameEnded, news, currentRound, rewards, gameTime } = studyGameState

    if (!isGameOn && !didGameEnded) {
        const variants = {
            open: {
                opacity: 1,
                display: 'block',
                transition: {
                    duration: 0.3,
                    ease: 'easeInOut'
                },
            },
            closed: { display: 'none', opacity: 0 },
        }

        return (
            <AnimationLayout>
                <h1 className='full-width'>Mundo em Notícias</h1>
                <article className='grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 justify-center items-center'>
                    <div>
                        <p className='mb-2'>
                            O mundo está sempre em mudança e há coisas a acontecer a todo e qualquer instante, por isso a Matilde precisa de si. Ajude-a a ficar atualizada com as notícias mais recentes do mundo e ganhe recompensas para usar nas suas viagens. Não perca mais tempo!</p>
                        <p>São <b>10 rondas</b> com <b>10 notícias</b> e vários <b>mini-jogos</b>. Se não conseguir resolver alguma das rondas, utilize a opção <b>“Saltar ronda”</b>. Mas cuidado! Tem apenas <b>3 saltos</b> possíveis.</p>
                    </div>
                    <div>
                        <img alt='test' className='object-contain' src={require('../assets/img/mundo-em-noticias/mundo-em-noticias-start.png')} />
                    </div>
                </article>
                <div className='w-full pt-12'>
                    <div className="white-container last:border-0">
                        {steps.map((label, index) => {
                            let addIndex = (index) => index += 1
                            return (
                                <span className="step" key={index}>
                                    <div className="vertical">
                                        <span className="step pb-2">
                                            <span className="icon-container">
                                                <svg className="step-icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                                    <circle cx="12" cy="12" r="12"></circle>
                                                    <text className="step-text" x="12" y="16" textAnchor="middle">{addIndex(index)}</text>
                                                </svg>
                                            </span>
                                            <span className="label-container">
                                                <h5 className='p-0'>{label.title}</h5>
                                            </span>
                                        </span>
                                        <motion.div
                                            animate={index === step ? "open" : "closed"}
                                            exit={{ opacity: 0 }}
                                            className="step-content"
                                            variants={variants}
                                            icon={addIndex(index)}
                                        >
                                            <div className="collapse-container collapse-entered">
                                                <div className="collapse-wrapper">
                                                    <div className="collapse-wrapper-inner">
                                                        <div>{getStepContent(index, language)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </motion.div>
                                    </div>
                                </span>
                            )
                        })}
                    </div>
                </div>
            </AnimationLayout>
        )
    } else if (didGameEnded) {
        return (
            <AnimationLayout>
                <h1 className='w-full'>Parte do mundo foi revelado em notícias</h1>
                <MatildeBalloon>
                    <p>Foi um estudo do mundo e das suas notícias muito proveitoso! Sinto-me agora mais confortável para viajar!</p>
                    <p>Continua assim e não te esqueças de continuar a ajudar-me!</p>
                </MatildeBalloon>

                <h3 className='w-full'>Nesta partida do Mundo em Notícias:</h3>
                <div className='grid w-full grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8 justify-center items-center pb-12'>
                    <div>
                        <ul>
                            <li className='mb-2'>Teve a duração de <b>{gameTime} minutos</b>.</li>
                            <li className='mb-2'>Recebeu <b>{rewards.exp} pontos de experiência</b>.</li>
                            <li className='mb-2'>
                                {rewards.items ?
                                    <div>
                                        <p className='mb-4'>Conquistou os seguintes itens:</p>
                                        <div className='grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6'>
                                            {rewards.items.map((item, index) => (
                                                <div className='white-container p-4 mb-0 flex justify-center' key={index}>
                                                    <img className='object-cover' alt={item.name} title={item.name} src={require(`../assets/img/items/${item.img}.png`)} />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <p>Infelizmente, não conquistou qualquer tipo de itens. <Emoji symbol='😢' label='triste' /></p>
                                    </div>
                                }
                            </li>
                        </ul>
                    </div>
                    <img
                        className='object-contain'
                        title='Matilde Vitoriosa'
                        alt='Matilde Vitoriosa'
                        src={require('../assets/img/mundo-em-noticias/mundo-em-noticias-end.png')}
                    />
                </div>

                <div className='flex flex-wrap justify-center md:justify-end items-center mb-4'>
                    <Link to='/dashboard'>
                        <Button onClick={() => dispatch({ type: 'QUIT_GAME' })} className='mb-2 md:mb-0'>
                            Voltar à página inicial
                        </Button>
                    </Link>
                    <Button onClick={() => window.location.reload()}>
                        Jogar novamente
                    </Button>
                </div>
            </AnimationLayout >
        )
    } else {
        const minigames = [
            ReorderWord,
            ReorderTitle,
            news[currentRound].image && GuessImage,
            news[currentRound].image && PuzzleMinigame,
            GuessTitle,
            GuessWord
        ]

        const MinigameComponent = minigames[getRandomInt(minigames.length)]

        return (
            studyGameState.error ?
                <div>
                    <h3>Ops! Ocorreu um erro na iniciação do jogo! <Emoji symbol='😥' label='Triste' /></h3>
                    <p>{studyGameState.error}</p>
                    <h3>Carregue no botão <i>"voltar"</i> para voltar à página de inicial do jogo.</h3>
                    <Button onClick={() => window.location.reload()}>Voltar</Button>
                </div>
                :
                <AnimationLayout>
                    <div className='grid grid-cols-1 gap-4 sm:gap-6 lg:gap-8'>
                        <MinigameComponent news={news[currentRound]} />
                    </div>
                </AnimationLayout>
        )
    }
}

export default StudyGame
